const InvestmentsChallenge1InitialText ="Some of the assertions that are currently in " +
    "the 'Statements that are False' column are actually true.  When you find a statement " +
    "that is true, drag it to the 'Statements that are True' column. " +
    "When you are done, click the 'Done' button."

export default InvestmentsChallenge1InitialText 
